const getCreatorDiscoverySidebarItems = (
  isDemoWorkspace: boolean,
  handleOpenCreatorSearchLockedModalForDemoWorkspace: () => void,
  baseUrl: string,
  isList: boolean,
) => [
  {
    to: isDemoWorkspace ? `#` : `${baseUrl}/campaign-creator-search`,
    onClick: handleOpenCreatorSearchLockedModalForDemoWorkspace,
    key: "front_sidebar_item_ai_creator_search",
    translateKey: "ws_creator_search",
    defaultMessage: "Creator Search",
  },
  {
    to: `${baseUrl}/creator-discovery-tool/lists`,
    key: "front_sidebar_item_creator_lists",
    translateKey: "ws_creator_lists",
    defaultMessage: "Creator Lists",
    activeLight: isList,
  },
  {
    to: isDemoWorkspace ? `#` : `${baseUrl}/hashtag-live-search`,
    onClick: handleOpenCreatorSearchLockedModalForDemoWorkspace,
    key: "front_sidebar_item_hashtags_live_search",
    translateKey: "ws_hashtag_live_search",
    defaultMessage: "Hashtag Live Search",
    activeLight: isList,
  },
];

export default getCreatorDiscoverySidebarItems;
